import Image from 'next/image'
import React from 'react'
import { useIntl } from 'react-intl'

export type ProposalAdvisorConversationAvatarProps = Readonly<{
  profilePicture?: string
  firstname: string
}>

export function ProposalAdvisorConversationAvatar({
  firstname,
  profilePicture,
}: ProposalAdvisorConversationAvatarProps) {
  const intl = useIntl()
  return profilePicture ? (
    <Image
      alt={intl.formatMessage(
        {
          id: 'ui.ProposalAdvisorConversationMessage.lastMessageDescription',
          defaultMessage: 'Un message de la part de {firstname}',
        },
        {
          firstname,
        },
      )}
      width={40}
      height={40}
      src={profilePicture}
      className='size-10 rounded-full'
    />
  ) : (
    <div className='flex size-10 shrink-0 items-center justify-center rounded-full border border-primary-500 bg-primary-50'>
      {firstname.slice(0, 1).toUpperCase()}
    </div>
  )
}
